<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="doc-header doc-title">
          <strong>{{ title }}</strong>
          <Button label="Xác nhận" class="p-button-danger p-button-sm" style="margin: 0px 10px 0 24px;" :disabled="selectedRows == null || selectedRows.length == 0" @click="onClickConfirm"/>
          <Button label="Xuất mã barcode" style="background: #0A84FF;" class="p-button-sm" :disabled="selectedRows == null || selectedRows.length == 0" @click="onExportExcelBarcode" v-if="this.$store.getters.group_permission && this.$store.getters.group_permission.insert_document.export == true || this.$store.getters.role == 'admin'"/>
          <!-- <Button label="Xuất mã barcode" style="background: #0A84FF;" class="p-button-sm" :disabled="selectedRows == null || selectedRows.length == 0" @click="onExportBarcode" v-if="this.$store.getters.group_permission && this.$store.getters.group_permission.insert_document.export == true || this.$store.getters.role == 'admin'"/> -->
          <!-- <Button label="GenerateJSON" @click="handlerGenerateJson($event)"/> -->
          <div class="box-selected-file">
            <input style="width: 100%" type="file" name="importFile" class="file" @change="onImportExcel"/>
            <span class="btn-span">Nhập file Excel</span>
          </div>
        </div>

        <DataTable
          :value="listData"
          class="p-datatable-responsive"
          dataKey="id"
          :selection.sync="selectedRows"
          :paginator="pagination"
          :rows="paginationRows"
          :loading="loading"
          :filters="filters"
          :scrollable="(scrollHeight !== '' ? true : false) "
          :scrollHeight="scrollHeight"
          :autoLayout="true"
          :key="componentKey"
          :rowsPerPageOptions="rowsPerPageOptions"
          currentPageReportTemplate="Tổng số văn bản: {totalRecords}"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        >
          <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
          <Column 
            v-for="c in dataModel.getDisplayFields()"
            :key="c.key"
            :field="getField(c)"
            :header="getLabel(c)"
            :filterMatchMode="getFilterMatch(c)"
            :filterFunction="customFilter"
            :sortable="getSortable(c)"
            :bodyClass="(c.class ? 'txt-' + c.class : '')"
            :bodyStyle="getHeaderStyle(c)"
            :headerStyle="getHeaderStyle(c)"
            :headerClass="(c.class ? 'txt-' + c.class : '')"
          >
            <template #body="slotProps">
              <img
                v-if="getType(c) == 'Image'"
                :src="getData(c, slotProps.data)"
                style="width: 40px; heigth: 40px"
              />
              <div
                v-else-if="c.type == 'Text'"
                v-html="getData(c, slotProps.data)"
                :style="(c.style ? c.style : '')"
              ></div>
              <div
                v-else-if="getType(c) == 'Custom' || getType(c) == 'Icon'"
                v-html="getData(c, slotProps.data)"
                :style="(c.style ? c.style : '')"
              ></div>

              <Checkbox
                v-else-if="getType(c) == 'Checkbox'"
                v-model="slotProps.data[slotProps.column.field]"
                :binary="true"
                @change="onInputChange($event, slotProps.data, c)"
              />
              <span v-else v-html="getData(c, slotProps.data)" :class="getCustomClass(c, slotProps.data[c.key], slotProps.data)"></span>
            </template>
            <template v-if="c.filter" #filter>
              <InputText
                v-if="c.filter.type == 'input'"
                type="text"
                v-model="filters[c.key]"
                class="p-column-filter"
                :placeholder="getFilterPlaceHolder(c)"
              />
              <Dropdown
                :key="countDropdown"
                v-if="c.filter.type == 'select'"
                v-model="filters[getField(c)]"
                :options="getFilterOptions(c.key)"
                :optionLabel="c.filter.optionLabel"
                :optionValue="c.filter.optionKey"
                :placeholder="getFilterPlaceHolder(c)"
                class="p-column-filter"
                :showClear="true"
                appendTo="body"
              >
                <template #option="slotProps">
                  <div class="p-clearfix">
                    <span
                      :class="getCustomClass(c, slotProps.option[c.filter.optionKey], slotProps.data)"
                      >{{ slotProps.option[c.filter.optionLabel] }}</span
                    >
                  </div>
                </template>
              </Dropdown>
              <!--<Calendar
                v-if="c.filter.type == 'DateRange'"
                :showOnFocus="false"
                :monthNavigator="true"
                :yearNavigator="true"
                yearRange="2000:2030"
                dateFormat="yy-mm-dd"
                id="date_from"
                v-model="filters[getField(c)]"
                class="p-column-filter"
                :showIcon="true"
                selectionMode="range"
                appendTo="body"
                :showClear="true"
                @date-select="select_date($event,c)"
                :manualInput="false"
                />-->
              <!--:dateFormat="formatDate('Date')"-->
              <Calendar
                  v-if="c.filter != undefined && c.filter.type == 'DateRange' && (c.filter.visible === undefined || (c.filter.visible !== undefined && c.filter.visible))"
                  :id="c.key + 'from'"
                  :dateFormat="$commonFuction.formatDateCalenda('Date')"
                  :value="getValueDateRange(c, 'from')"
                  class="p-column-filter date-custom"
                  :showIcon="true"
                  :showButtonBar="true"
                  :manualInput="false"
                  appendTo="body"
                  :placeholder="'Từ ngày'"
                  @date-select="selectChangeDate($event, c, 'from')"
                  @clear-click="clearChangeDate( c, 'from')"

              />
              <Calendar
                  v-if="c.filter != undefined && c.filter.type == 'DateRange' && (c.filter.visible === undefined || (c.filter.visible !== undefined && c.filter.visible))"
                  :id="c.key + 'to'"
                  :dateFormat="$commonFuction.formatDateCalenda('Date')"
                  :value="getValueDateRange(c, 'to')"
                  class="p-column-filter date-custom"
                  :showIcon="true"
                  :showButtonBar="true"
                  :manualInput="false"
                  appendTo="body"
                  :placeholder="'Đến ngày'"
                  @date-select="selectChangeDate($event, c, 'to')"
                  @clear-click="clearChangeDate(c, 'to')"
              />
            </template>
          </Column>
          <Column
            v-if="getRowActions()"
            headerStyle="width: 8em; text-align: center"
            bodyStyle="width: 8em; text-align: center"
          >
            <template #body="slotProps">
              <span class="p-column-title">Actions</span>
              {{ slotProps.data.color }}
              <Button
                v-for="(a, k) in getRowActions().rows(slotProps.data)"
                :key="k"
                type="button"
                :icon="getIcon(a.icon)"
                :class="getClass(a.name)"
                :disabled="getDisabled(a.disabled)"
                style="margin-right: 0.5em;"
                v-on:click="actionsClicked(k, a, slotProps)"
              ></Button>
            </template>
            <template #header="slotProps">
              <Button
                v-if="getRowActions().header"
                type="button"
                :icon="getIcon(getRowActions().header.icon)"
                :class="getClass(getRowActions().header.name)"
                v-on:click="actionsClicked(getRowActions().header.name, getRowActions().header, slotProps)"
              ></Button>
            </template>
          </Column>
          <template #empty>
            {{ $t('datatable.empty') }}
          </template>
          <template #loading>
            {{ $t('datatable.loading') }}
          </template>
        </DataTable>

        <!-- <div class="card">Tổng số văn bản: {{ totalDoc }}</div> -->
        <div style="display: none;">
          <img id='barcode' />
        </div>

        <Dialog
          header="Xóa"
          :visible.sync="showDeleteDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          Bạn có chắc muốn xóa <strong>{{this.deleteName}}</strong>
          <template
            #footer
          >
            <Button label="Xóa" @click="deleteData()" icon="pi pi-check" class="p-button-danger" />
            <Button
              label="Hủy"
              @click="showDeleteDialog = false"
              icon="pi pi-times"
              class="p-button-warning"
            />
          </template>
        </Dialog>
        
        <Dialog :visible.sync="showload"
          id="loading"
          :modal="true"
          :closable="false"
          :showHeader="false"
        >
          <ProgressSpinner style="width:50px;height:50px" />
        </Dialog>

      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import gql from "graphql-tag";
import moment from "moment-timezone";
import XLSX from "xlsx"
import jsPDF from "jspdf"
import JsBarcode from 'jsbarcode'
import 'jspdf-autotable'
// import $ from 'jquery'
import graphql from '../common/graphql'
import store from '@/store'
// import jsonDistrict from './district.json'
// import jsonWard from './ward.json'
// import jsonProvince from './province.json'
export default {
  components: {
    // BaseDatatable,
    // xlsx
  },
  data() {
    return {
      filterOptions: {},
      listData: [],
      options: [],
      modelName: '',
      dataModel: null,
      title: '',
      componentKey: 0,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      totalDoc: 0,
      // 
      filters: {},
      countDropdown: 0,
      pagination: true, // true cho phép phân trang
      paginationRows: 10, // số dòng trên 1 trang
      scrollHeight: '', // chiều cao của trang danh sách
      loading: true,
      rowsPerPageOptions: [10, 20, 50, 100],
      selectedRows: null,
      // IMPORT
      hasErrors: 0,
      lstCurrDocument: {},
      onlyName: [],
      onlyDate: [],
      onlyAddress: [],
      lstCurrState: {},
      lstCurrDistrict: {},
      lstCurrWard: {},
      lstCurrOfficeTPL: {},
      lstCurrOfficeAgency: {},
      lstCurrArea: {},
      state_id: null,
      type_state: null,
      district_id: null,
      tpl_id: null,
      agency_id: null,
      area_id: null,
      is_fee_budget: 0,
      is_urgent : false,
      type_document: 1,
      code_system: null,
      tdv_id: null,
      phone_tdv: null,
      showload : false,
      // 
      // provinces: jsonProvince,
      // districts: jsonDistrict,
      // wards: jsonWard,
      users_login: null,
      type_custom_filter:null,
      dateType: 0,
    }
  },
  beforeCreate() {
    if (store.getters.group_permission && store.getters.group_permission.insert_document.list == false && store.getters.role != "admin") {
      this.$router.push({name: '404'})
    }
  },
  created() {
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel('document')
    this.title = this.dataModel.name
    this.$store.commit('setLoading', true);
    // if(this.$route.params.reload) {
    //   window.location.reload();
    // }
    this.getUserLogin();

    this.loading = false;
    this.countDropdown++;
    this.$apollo.queries.listData.refresh();
    this.callbackOptions();
  },
  mouted() {
  },
  watch: {
    '$route': 'initParams'
  },
  methods: {
    initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel('document');
      // console.log(this.dataModel)
      this.title = this.dataModel.label;
    },
    async getUserLogin(){
      await this.$apollo.query({
        query: DataServices.getList('accounts', {"fields" : "users {id}"}),
        variables: {
          where_key: {
            id : {'_eq' : this.$store.getters.user}
          }
        },
        fetchPolicy: "no-cache"
      }).then((res) => {
        if (res.data.accounts && res.data.accounts[0] && res.data.accounts[0].users) {
          this.users_login = res.data.accounts[0].users.id
        }
      })
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      return result;
    },
    async callbackOptions() {
      var fields = this.dataModel.getDisplayFields()
      var attributes = [];
      for (let index = 0; index < fields.length; index++) {
        const element = fields[index];
        if (element.models !== undefined && element.models !== null) {
          var optionsData = [];
          attributes.push(element.models.key.key);
          attributes.push(element.models.display_key);
          var where_status = {}
          var tableName = element.models.tableName
          var {data} = await this.$apollo.query({
            query: DataServices.getList(tableName, {"fields" : attributes.join(',')}),
            variables: {where_key : where_status}
          })
          if (data) {
            var result = data[Object.keys(data)];
            if (result) {
              for (let index = 0; index < result.length; index++) {
                const ele = result[index];
                optionsData.push({value: ele[attributes[0]], label: ele[attributes[1]]})
              }
            }
          }
          this.options[element.key] = optionsData;
        }
        this.componentKey++;
      }
    },
    getRowActions() {
      var actions = {}
      var that = this;
      if ((store.getters.group_permission && store.getters.group_permission.insert_document.add == true) || store.getters.role == "admin") {
        actions.header = { name: 'add', icon: 'plus', path: `import-document/add`};
      }
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {}
        // buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-manager/view/`};
        var hasEditAfterSalaryPermission = store.getters.group_permission && store.getters.group_permission.edit_document_after_salary && store.getters.group_permission.edit_document_after_salary.edit == true;
        var isSalaryLockedForEdit = (store.getters.role == 'dpv' || store.getters.role == 'court') && !hasEditAfterSalaryPermission && rowData.status_document && rowData.status_document.ordinal >= 9;
        if (!isSalaryLockedForEdit && ((store.getters.group_permission && store.getters.group_permission.insert_document.edit == true) || store.getters.role == "admin")) {
          buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `import-document/edit/`};
        }
        // buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `${that.modelName}/edit/`}
        if ((store.getters.group_permission && store.getters.group_permission.insert_document.delete == true) || store.getters.role == "admin") {
          buttons.delete = { name: 'delete', icon: 'trash', key: 'id'}
        }
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async actionsClicked(key, action, data) {
      // var action = payload.action
      // var data = null
      // if (payload.data) {
      //   data = payload.data
      // }
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    deleteData() {
      this.showDeleteDialog = false
      /*var query = DataServices.deleteData(this.modelName)
      var variables = {
        where_key: {
          id: {'_eq': this.deleteId}
        }
      }
      this.$apollo.mutate({
        mutation: query,
        variables: variables
      }).then(res => {
        if (res.data.delete_document.affected_rows > 0) {
          this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa dữ liệu thành công', life: 3000 })
        } else this.$toast.add({ severity: 'error', summary: 'Thất bại', detail: 'Xóa dữ liệu thất bại', life: 3000 })
        this.$apollo.queries.listData.refresh()
      }).catch((error) => {
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Xóa dữ liệu gặp vấn đề', life: 3000 })
        console.error('ERROR: ', error)
      });

      */
      var query = DataServices.updateData(this.modelName)
      var variables = {
        where_key: {
          id: {'_eq': this.deleteId}
        },
        'data_update': {
          'deleted': true
        },
      }
      this.$apollo.mutate({
        mutation: query,
        variables: variables
      }).then(() => {
        //if (res.data.delete_document.affected_rows > 0) {
          this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa dữ liệu thành công', life: 3000 })
        //} else this.$toast.add({ severity: 'error', summary: 'Thất bại', detail: 'Xóa dữ liệu thất bại', life: 3000 })
        this.$apollo.queries.listData.refresh()
      }).catch((error) => {
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Xóa dữ liệu gặp vấn đề', life: 3000 })
        console.error('ERROR: ', error)
      });


    },
    async onClickConfirm() {
      let arrIDs = [];
      let arrNotAssign = [];
      if (this.selectedRows && this.selectedRows.length > 0) {
        for (let i = 0; i < this.selectedRows.length; i++) {
          if(this.selectedRows[i].scan_barcode === false){
            this.$toast.add({ 
              severity: 'error', 
              summary: 'Lỗi', 
              detail: 'Vui lòng chọn VB đã in mã code.', 
              life: 180000 
            });
            return;
          }
          for (let j = 0; j < this.listData.length; j++) {
            if (this.listData[j].id === this.selectedRows[i].id && this.listData[j].tdv !== null) {
              arrIDs.push(this.selectedRows[i].id)
            } else if (this.listData[j].id === this.selectedRows[i].id && this.listData[j].tdv === null) {
              arrNotAssign.push(this.selectedRows[i].code_system)
            }
          }
        }
      }
      // console.log(arrIDs);
      // console.log(arrNotAssign);
      if (arrIDs.length > 0) {
        let variables = {
          'data_update': {
            // date_tdv_receipt: new Date().toISOString(),
            status_vb_id: 2,
            is_confirmed: true
          },
          'where_key': {
            id: {'_in': arrIDs}
          }
        };
        await this.$apollo.mutate({
          mutation: DataServices.updateData('document'),
          variables: variables
        }).then(async (res) => {
          if (res.data[Object.keys(res.data)].affected_rows) {
            this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Cập nhật dữ liệu thành công', life: 3000 })
            this.$store.commit('setLoading', true);
            this.selectedRows = null
            this.$apollo.queries.listData.refresh()
          }
        }).catch((error) => {
          this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Cập nhật dữ liệu gặp vấn đề', life: 3000 })
          console.error('ERROR: ', error)
        });
      }
      if (arrNotAssign.length > 0) {
        this.$toast.add({ severity: 'error', summary: 'Cảnh báo', detail: 'Một số văn bản không có TĐV: ' + arrNotAssign.join(', '), life: 7000 })
      }
    },
    async onExportExcelBarcode() {
      let arrIDs = [];
      let arrNotAssign = [];
      if (this.selectedRows && this.selectedRows.length > 0) {
        this.$store.commit("setLoading", true);
        var dataJson = [];
        for (let index = 0; index < this.selectedRows.length; index++) {
          var item = this.selectedRows[index];
          if (item['code_system'] != undefined && item['code_system'] != '' && 
            item['name_litigant'] != undefined && item['name_litigant'] != '' ) {
            dataJson.push({
              'Mã vạch': item['code_system'],
              'Tên đương sự': item['name_litigant'].slice(0,18)
            });
          }
          for (let j = 0; j < this.listData.length; j++) {
            if (this.listData[j].id === item.id && this.listData[j].tdv !== null) {
              arrIDs.push(item.id)
              break;
            } else if (this.listData[j].id === item.id && this.listData[j].tdv === null) {
              arrNotAssign.push(item.code_system)
            }
          }
        }
        if (dataJson !== null) {
          var dataSheet = XLSX.utils.json_to_sheet(dataJson) 
          var wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, dataSheet)
          XLSX.writeFile(wb, 'barcode.xlsx')
          this.$store.commit('setLoading', true);
        }
        if (arrIDs.length > 0) {
          let variables = {
            'data_update': {
              // is_confirmed: true,
              // date_tdv_receipt: new Date().toISOString(),
              // status_vb_id: 2,
              scan_barcode: true
            },
            'where_key': {
              id: {'_in': arrIDs}
            }
          };
          await this.$apollo.mutate({
            mutation: DataServices.updateData('document'),
            variables: variables
          }).then(async (res) => {
            if (res.data[Object.keys(res.data)].affected_rows) {
              // this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Cập nhật dữ liệu thành công', life: 3000 })
              // this.$store.commit('setLoading', true);
              this.$apollo.queries.listData.refresh()
            }
          }).then(async () => {
            location.reload();
          }).catch((error) => {
            this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Cập nhật dữ liệu gặp vấn đề', life: 10000 })
            console.error('ERROR: ', error)
          });
        }
        if (arrNotAssign.length > 0) {
          this.$toast.add({ severity: 'error', summary: 'Cảnh báo', detail: 'Một số văn bản không có TĐV: ' + arrNotAssign.join(', '), life: 10000 })
        }
      }
    },
    async onExportBarcode() {
      // console.log('Xuat barcode: ', this.selectedRows)
      // CẬP NHẬT CỘT IN BARCODE
      let arrIDs = [];
      let arrNotAssign = [];
      if (this.selectedRows && this.selectedRows.length > 0) {
        for (let i = 0; i < this.selectedRows.length; i++) {
          for (let j = 0; j < this.listData.length; j++) {
            if (this.listData[j].id === this.selectedRows[i].id && this.listData[j].tdv !== null) {
              arrIDs.push(this.selectedRows[i].id)
            } else if (this.listData[j].id === this.selectedRows[i].id && this.listData[j].tdv === null) {
              arrNotAssign.push(this.selectedRows[i].code_system)
            }
          }
        }
      }
      // console.log(arrIDs);
      // console.log(arrNotAssign);
      if (arrIDs.length > 0) {
        let variables = {
          'data_update': {
            is_confirmed: true,
            date_tdv_receipt: new Date().toISOString(),
            status_vb_id: 2,
            scan_barcode: true
          },
          'where_key': {
            id: {'_in': arrIDs}
          }
        };
        await this.$apollo.mutate({
          mutation: DataServices.updateData('document'),
          variables: variables
        }).then(async (res) => {
          if (res.data[Object.keys(res.data)].affected_rows) {
            this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Cập nhật dữ liệu thành công', life: 3000 })
            this.$store.commit('setLoading', true);
            this.$apollo.queries.listData.refresh()
          }
        }).then(async () => {
          var doc = new jsPDF('p', 'mm');
          var x = 10;
          var y = 5;
          var width = 55;
          var height = 25;
          var count = 0;
          // var pageWidth = 210;
          var pageHeight = 295;
          for (let i = 0; i < this.selectedRows.length; i++) {
            let code = this.selectedRows[i].code_system;
            // console.log(code);
            // console.log(count)
            // console.log(x)
            // console.log(y)
            JsBarcode("#barcode", code, {format: "CODE128"});
            const img = document.querySelector('img#barcode');
            doc.addImage(img.src, 'PNG', x, y, width, height);
            count++;
            if (count == 3) {
              // SET LẠI BAN ĐẦU KHI NHẢY QUA HÀNG TIẾP THEO
              count = 0;
              x = 10;
              y += (height + 4);
            } else {
              // IN CÙNG HÀNG
              x += (12 + width);
            }

            if (y + height >= pageHeight) {
              doc.addPage(); // break-page
              x = 10;
              y = 5;
            }
          }
          doc.save('barcode.pdf');
          this.selectedRows = null;
        }).catch((error) => {
          this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Cập nhật dữ liệu gặp vấn đề', life: 3000 })
          console.error('ERROR: ', error)
        });
      }
      if (arrNotAssign.length > 0) {
        this.$toast.add({ severity: 'error', summary: 'Cảnh báo', detail: 'Một số văn bản không có TĐV: ' + arrNotAssign.join(', '), life: 4000 })
      }
    },
    async onImportExcel(e) {
      // console.log(e, 'Import excel')
      this.$store.commit("setLoading", true);
      let files = e.target.files || e.dataTransfer.files
      let life = 1800000;
      if (!files.length) return
      if (files[0].name.split('.').pop() !== 'xlsx' && files[0].name.split('.').pop() !== 'XLSX' && files[0].name.split('.').pop() !== 'xls' && files[0].name.split('.').pop() !== 'XLS') {
        this.$store.commit("setLoading", false);
        this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Vui lòng nhập file có định dạng xlsx', life: life })
        return
      }
      // Lấy dữ liệu DB hiện tại
      await this.$apollo.query({
        query: gql(graphql.GET_DOCUMENT),
        variables: {
          orderBy: {id: 'asc'}
        }
      }).then((res) => {
        // console.log(res)
        if (res.data.document.length > 0) {
          for (let i = 0; i < res.data.document.length; i++) {
            const el = res.data.document[i];
            if (el.code_area == null) el.code_area = ''
            if (el.code_office == null) el.code_office = ''
            if (el.code_court == null) el.code_court = ''
            if (el.code_agency == null) el.code_agency = ''
            if (el.number_decision == null) el.number_decision = ''
            this.lstCurrDocument[el.code_area+el.code_office+el.code_court+el.code_agency+el.number_decision] = el
          }
        }
        console.log('lstCurrDocument: ', this.lstCurrDocument)
      }).catch((error) => {
        this.$store.commit("setLoading", false);
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Lấy dữ liệu văn bản gặp vấn đề', life: life })
        console.error('ERROR: ', error)
        return
      });

      /*await this.$apollo.query({
        query: gql(graphql.GET_STATE),
      }).then((res) => {
        // console.log(res)
        if (res.data.state.length > 0) {
          for (let i = 0; i < res.data.state.length; i++) {
            const element = res.data.state[i];
            this.lstCurrState[element.name] = element.id
          }
        }
        // console.log('lstCurrState: ', this.lstCurrState)
      }).catch((error) => {
        this.$store.commit("setLoading", false);
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Lấy dữ liệu tỉnh/thành gặp vấn đề', life: life })
        console.error('ERROR: ', error)
        return
      });*/

      /*await this.$apollo.query({
        query: gql(graphql.GET_DISTRICT),
      }).then((res) => {
        // console.log(res)
        if (res.data.district.length > 0) {
          for (let i = 0; i < res.data.district.length; i++) {
            const element = res.data.district[i];
            this.lstCurrDistrict[element.name+element.state_id] = element
          }
        }
        // console.log('lstCurrDistrict: ', this.lstCurrDistrict)
      }).catch((error) => {
        this.$store.commit("setLoading", false);
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Lấy dữ liệu quận/huyện gặp vấn đề', life: life })
        console.error('ERROR: ', error)
        return
      });*/

      /*await this.$apollo.query({
        query: gql(graphql.GET_WARD),
      }).then((res) => {
        // console.log(res)
        if (res.data.ward.length > 0) {
          for (let i = 0; i < res.data.ward.length; i++) {
            const element = res.data.ward[i];
            this.lstCurrWard[element.name+element.district_id] = element
          }
        }
        // console.log('lstCurrWard: ', this.lstCurrWard)
      }).catch((error) => {
        this.$store.commit("setLoading", false);
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Lấy dữ liệu phường/xã gặp vấn đề', life: life })
        console.error('ERROR: ', error)
        return
      });*/
      var variablesOfficeTpl = {
        where: {
          deleted: {_eq: false}
        },
      }
      await this.$apollo.query({
        query: gql(graphql.GET_OFFICE_TPL),
        variables: variablesOfficeTpl
      }).then((res) => {
        // console.log(res)
        if (res.data.office_tpl.length > 0) {
          for (let i = 0; i < res.data.office_tpl.length; i++) {
            const element = res.data.office_tpl[i];
            this.lstCurrOfficeTPL[element.code] = element
          }
        }
        console.log('lstCurrOfficeTPL: ', this.lstCurrOfficeTPL)
      }).catch((error) => {
        this.$store.commit("setLoading", false);
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Lấy dữ liệu văn phòng gặp vấn đề', life: life })
        console.error('ERROR: ', error)
        return
      });
      var variablesOfficeAgency = {
        where: {deleted: {_eq: false}},
      }
      await this.$apollo.query({
        query: gql(graphql.GET_OFFICE_AGENCY),
        variables: variablesOfficeAgency
      }).then((res) => {
        // console.log(res)
        if (res.data.office_agency.length > 0) {
          for (let i = 0; i < res.data.office_agency.length; i++) {
            const element = res.data.office_agency[i];
            this.lstCurrOfficeAgency[element.code] = element
          }
        }
        console.log('lstCurrOfficeAgency: ', this.lstCurrOfficeAgency)
      }).catch((error) => {
        this.$store.commit("setLoading", false);
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Lấy dữ liệu cơ quan gặp vấn đề', life: life })
        console.error('ERROR: ', error)
        return
      });
      var variablesArea = {
        where: {
          deleted: {_eq: false}
        },
      }
      await this.$apollo.query({
        query: gql(graphql.GET_AREA),
        variables: variablesArea
      }).then((res) => {
        // console.log(res)
        if (res.data.area.length > 0) {
          for (let i = 0; i < res.data.area.length; i++) {
            const element = res.data.area[i];
            this.lstCurrArea[element.code] = element
          }
        }
        console.log('lstCurrArea: ', this.lstCurrArea)
      }).catch((error) => {
        this.$store.commit("setLoading", false);
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Lấy dữ liệu khu vực gặp vấn đề', life: life })
        console.error('ERROR: ', error)
        return
      });
      var f = files[0];
      var reader = new FileReader();
      var that = this;
      reader.onload = async function(e) {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, {type: 'array'});
        let sheetName = workbook.SheetNames[0];
        /* DO SOMETHING WITH workbook HERE */
        let worksheet = workbook.Sheets[sheetName];
        let worksheet_json = XLSX.utils.sheet_to_json(worksheet, {defval:"",raw:false})//Thêm raw:false để lấy format date
        // console.log(worksheet_json);
        await that.addData(worksheet_json);
      }
      reader.readAsArrayBuffer(f);
      // this.$store.commit("setLoading", false);
      // this.$apollo.queries.listData.refresh();
      // setTimeout(function () {
      //   location.reload()
      // }, 1000)
    },
    async addData(worksheet_json){
      this.showload = true;
      let life = 1800000;
      var list_change_docs = [];
      for (let i = 0; i < worksheet_json.length; i++) {
        // that.$store.commit("setLoading", true);
        if (this.hasErrors == 1) {
          this.showload = true;
          break
        }
        const element = worksheet_json[i];
        var data_import = {}
        let counter = 0
        var data_document = {}
        for (const key in element) {
          if (Object.prototype.hasOwnProperty.call(element, key)) {
            let t = element[key];
            if (counter == 0) {
              data_import['code_office'] = t
            } else if (counter == 1) {
              data_import['code_area'] = t
            } else if (counter == 2) {
              if( t !== undefined && t !== null){
                data_import['code_court'] = t
              }else{
                data_import['code_court'] = ''
              }
            } else if (counter == 3) {
              if( t !== undefined && t !== null){
                data_import['number_decision'] = t
              }else{
                data_import['number_decision'] = ''
              }
            } else if (counter == 4) {
              data_import['content_document'] = t
            } else if (counter == 5) {
              /*console.log("date_issued1111:",t);
              console.log("date_issued1111:",moment(t,"MM/DD/YYYY").format('YYYY-MM-DD'));
              console.log("date_issued1111:",moment(t,"DD/MM/YYYY").utc(7).format());
              console.log("date_issued1111:",new Date(moment(t,"DD/MM/YYYY").utc(7).format()));*/
              if(t !== '' && t !== null){
                data_import['date_issued'] = t
              }else{
                data_import['date_issued'] = null
              }
            } else if (counter == 6) {
              if(t !== '' && t !== null){
                data_import['date_invite'] = t
              }else{
                data_import['date_invite'] = null
              }
            } else if (counter == 7) {
              data_import['name_litigant'] = t
            } else if (counter == 8) {
              data_import['address'] = t
            } else if (counter == 9) {
              data_import['ward'] = t.toString()
            } else if (counter == 10) {
              data_import['district'] = t.toString()
            } else if (counter == 11) {
              data_import['state'] = t.toString()
            } else if (counter == 12) {
              data_import['signer'] = t
            } else if (counter == 13) {
              data_import['code_agency'] = t
            } else if (counter == 14) {
              data_import['is_urgent'] = t
            } else if (counter == 15) {
              data_import['is_fee_budget'] = t
            }
            // 
          }
          counter++
        }
        // console.log('===> data import: ', data_import)
        if (data_import['code_office'] === '' || data_import['code_office'] == undefined) {
          this.$toast.add({ severity: 'error', summary: 'Import văn bản lỗi', detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Mã văn phòng không được để trống", life: life })
          this.hasErrors = 1
          break   
        }
        if (data_import['code_area'] === '' || data_import['code_area'] == undefined) {
          this.$toast.add({ severity: 'error', summary: 'Import văn bản lỗi', detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Mã khu vực không được để trống", life: life })
          this.hasErrors = 1
          break   
        }
        if (data_import['code_agency'] === '' || data_import['code_agency'] == undefined) {
          this.$toast.add({ severity: 'error', summary: 'Import văn bản lỗi', detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Mã cơ quan không được để trống", life: life })
          this.hasErrors = 1
          break   
        }
        if (data_import['content_document'] === '' || data_import['content_document'] == undefined) {
          this.$toast.add({ severity: 'error', summary: 'Import văn bản lỗi', detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Nội dung văn bản không được để trống", life: life })
          this.hasErrors = 1
          break   
        }
        if (data_import['name_litigant'] === '' || data_import['name_litigant'] == undefined) {
          this.$toast.add({ severity: 'error', summary: 'Import văn bản lỗi', detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Tên đương sự không được để trống", life: life })
          this.hasErrors = 1
          break   
        }
        if (data_import['address'] === '' || data_import['address'] == undefined) {
          this.$toast.add({ severity: 'error', summary: 'Import văn bản lỗi', detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Địa chỉ không được để trống", life: life })
          this.hasErrors = 1
          break   
        }
        if (data_import['ward'] === '') {
          this.$toast.add({ severity: 'error', summary: 'Import văn bản lỗi', detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Phường/xã không được để trống", life: life })
          this.hasErrors = 1
          break   
        }
        // if (data_import['district'] === '') {
        //   this.$toast.add({ severity: 'error', summary: 'Import văn bản lỗi', detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Quận/huyện không được để trống", life: life })
        //   this.hasErrors = 1
        //   break   
        // }
        if (data_import['state'] === '') {
          this.$toast.add({ severity: 'error', summary: 'Import văn bản lỗi', detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Tỉnh/thành phố không được để trống", life: life })
          this.hasErrors = 1
          break   
        }
        // check quận có thuộc tỉnh
        console.log("this.$commonFuction.SkipVN(data_import['state'].trim())",this.$commonFuction.SkipVN(data_import['state'].trim()));
        var getState =await this.$CoreService.getObjectData('state',{plain_name: {_eq: this.$commonFuction.SkipVN(data_import['state'].trim())}});
        //console.log("getStategetStategetState:",getState)
        // if (data_import['state'] in this.lstCurrState) {
        if (getState) {
          //this.state_id = this.lstCurrState[data_import['state']]
          this.state_id = getState.id;
          this.type_state = getState.type;
          var getDistrict = null;
          if(data_import['district'] !== ''){
            getDistrict  =await this.$CoreService.getObjectData('district',{plain_name: {_eq: this.$commonFuction.SkipVN(data_import['district'].trim())}, state_id: {_eq: this.state_id}});
          }
          /*if ((data_import['district']+this.state_id in this.lstCurrDistrict) && (this.lstCurrDistrict[data_import['district']+this.state_id].state_id == this.state_id)) {
            this.district_id = this.lstCurrDistrict[data_import['district']+this.state_id].id
          }*/
          //console.log("getDistrictgetDistrictgetDistrict:",getDistrict)
          if (getDistrict) {
            this.district_id = getDistrict.id;
          }else{
            this.district_id = null;
          }
          // console.log(that.district_id);
          if ((!this.district_id || this.district_id == null) && data_import['district'] !== '') {
            this.$toast.add({
              severity: "error",
              summary: "Import văn bản thất bại",
              detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Quận/huyện không chính xác hoặc không thuộc Tỉnh/thành phố tương ứng",
              life: life
            });
            this.hasErrors = 1
            // return
          } else {
            // check phường xã
            // console.log(data_import['ward'])
            var where_ward= {plain_name: {_eq: this.$commonFuction.SkipVN(data_import['ward'].trim())}};
            if(this.district_id){
              where_ward.district_id = {_eq: this.district_id}
            }else{
              where_ward.state_id_merger = {_eq: this.state_id}
            }
            var getWard  =await this.$CoreService.getObjectData('ward',where_ward);
            //if ((data_import['ward']+this.district_id in this.lstCurrWard) && (this.lstCurrWard[data_import['ward']+this.district_id].district_id == this.district_id)) {
            if (getWard) {
              //this.ward_id = this.lstCurrWard[data_import['ward']+this.district_id].id
              this.ward_id = getWard.id
              // console.log(that.ward_id);
              if (!this.ward_id || this.ward_id == null) {
                this.$toast.add({
                  severity: "error",
                  summary: "Import văn bản thất bại",
                  detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Phường/xã không chính xác hoặc không thuộc Quận/huyện tương ứng",
                  life: life
                });
                this.hasErrors = 1
                break
              }
            } else {
              this.$toast.add({
                severity: "error",
                summary: "Import văn bản thất bại",
                detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Phường/xã không chính xác",
                life: life
              });
              this.hasErrors = 1
              break
            }
          }
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Import văn bản thất bại",
            detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Tỉnh/thành phố không chính xác",
            life: life
          });
          this.hasErrors = 1
          break
        }
        // check mã văn phòng ko tồn tại
        console.log("this.lstCurrOfficeTPLthis.lstCurrOfficeTPLthis.lstCurrOfficeTPL",this.lstCurrOfficeTPL);
        console.log("data_import['code_office']data_import['code_office']",data_import['code_office']);
        if (data_import['code_office'] in this.lstCurrOfficeTPL) {
          this.tpl_id = this.lstCurrOfficeTPL[data_import['code_office']].id
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Import văn bản thất bại",
            detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Mã văn phòng không chính xác",
            life: life
          });
          this.hasErrors = 1
          break
        }
        // check mã cơ quan ko tồn tại
        if (data_import['code_agency'] in this.lstCurrOfficeAgency) {
          this.agency_id = this.lstCurrOfficeAgency[data_import['code_agency']].id
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Import văn bản thất bại",
           // detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Mã văn phòng không chính xác",
            detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Mã cơ quan không chính xác",
            life: life
          });
          this.hasErrors = 1
          break
        }
        // check mã khu vực ko tồn tại
        console.log("this.lstCurrAreathis.lstCurrArea",this.lstCurrArea);
        if (data_import['code_area'] in this.lstCurrArea) {
          this.area_id = this.lstCurrArea[data_import['code_area']].id
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Import văn bản thất bại",
            //detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Mã văn phòng không chính xác",
            detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Mã khu vực không chính xác",
            life: life
          });
          this.hasErrors = 1
          break
        }
        // change data
        if (data_import['is_urgent'] == '' || data_import['is_urgent'] == null || data_import['is_urgent'] == undefined) {
          this.is_urgent = false
        } else {
          this.is_urgent = true
        }
        if (data_import['is_fee_budget'] == 'Ngân sách') {
          this.is_fee_budget = 1
        } else if (data_import['is_fee_budget'] == 'Đương sự') {
          this.is_fee_budget = 2
        } else {
          this.is_fee_budget = 0
        }

        // generate code system
        let cDate = moment(new Date()).format('DDMMYY');
        let cAgency = data_import['code_agency'].toString().substring(0, 2).toUpperCase();
        let cArea = data_import['code_area'].toString().substring(0, 2).toUpperCase();
        let cOffice = data_import['code_office'].toString().substring(0, 2).toUpperCase();
        var date1 = new Date().toISOString()
        date1 = moment(date1).utc(7).format('YYYY-MM-DDT00:00:00.0[Z]')
        var date2 = new Date().toISOString()
        date2 = moment(date2).utc(7).format('YYYY-MM-DDT23:59:59.0[Z]')
        var cNumber = 0;

        await this.$apollo.query({
          query: gql(graphql.GET_SETTING_CURRENT_DOCUMENT),
          variables: {
            where: {
              created_at: {'_gte': date1, '_lte': date2}
            },
            limit: 1
          },
          fetchPolicy: "network-only"
        }).then((res) => {
          if (res.data && res.data.setting_current_document.length > 0) {
            cNumber = res.data.setting_current_document[0].current + 1
          }
        })
        let sequence =  this.padLeft(cNumber, 4);
        this.code_system = cDate + cAgency + cArea + cOffice + sequence;

        // check tạo văn bản
        if (data_import['date_invite'] !== null && typeof data_import['date_invite'] === 'string') {
          /*let dateInvite = data_import['date_invite'].toString().split('/').reverse().join('-')
          dateInvite = new Date(dateInvite)
          console.log("dateInvite:",dateInvite)
          data_document['date_invite'] = dateInvite.toISOString()*/
          //check neu thời gian sai định dạng sẽ ko import
          var checkTimeInvite = new Date(moment(data_import['date_invite'],"DD/MM/YYYY").utc(7).format());
          if (!isNaN(checkTimeInvite.getTime())){
            data_document['date_invite'] = moment(data_import['date_invite'],"DD/MM/YYYY").utc(7).format()
          }
        }
        if (data_import['date_issued'] !== null && typeof data_import['date_issued'] === 'string') {
          /*let dateIssued = data_import['date_issued'].toString().split('/').reverse().join('-')
          dateIssued = new Date(dateIssued)
          console.log("dateIssued:",dateIssued)*/
          //check neu thời gian sai định dạng sẽ ko import
          var checkTimeIssued = new Date(moment(data_import['date_issued'],"DD/MM/YYYY").utc(7).format());
          if (!isNaN(checkTimeIssued.getTime())){
            data_document['date_issued'] = moment(data_import['date_issued'],"DD/MM/YYYY").utc(7).format()
          }

        }
        data_document['code_court'] = data_import['code_court'].toString()
        data_document['code_office'] = data_import['code_office'].toString()
        data_document['code_agency'] = data_import['code_agency'].toString()
        data_document['code_area'] = data_import['code_area'].toString()
        data_document['number_decision'] = data_import['number_decision'].toString()
        data_document['content_document'] = data_import['content_document'].toString()
        data_document['name_litigant'] = data_import['name_litigant'].toString()
        data_document['address'] = data_import['address'].toString()
        data_document['state_id'] = this.state_id;
        data_document['type_state'] = this.type_state
        data_document['district_id'] = this.district_id
        data_document['ward_id'] = this.ward_id
        data_document['is_fee_budget'] = this.is_fee_budget
        data_document['signer'] = data_import['signer'].toString()
        data_document['is_urgent'] = this.is_urgent
        await this.assignTDV(this.ward_id)
        data_document['tdv_id'] = this.tdv_id
        data_document['phone_tdv'] = this.phone_tdv
        // console.log('=============== tao van ban2: ')
        // TẠO MỚI VĂN BẢN
        data_document['code_system'] = this.code_system
        data_document['is_import'] = 1 // ĐỂ RUN TRIGGER UPDATE LOẠI VB
        data_document['status_td_id'] = null
        if(this.users_login !== null){
          data_document['created_uid'] = this.users_login;
        }
        //console.log("data_documentdata_documentdata_documentdata_document",data_document)
        var dateCurrent = moment().tz(this.$constants.DB_TIMEZONE).format(this.$constants.DB_FORMAT_DATE);
        var dateFrom = dateCurrent+' 00:00:00';
        var dateTo = dateCurrent+' 23:59:59';
        //Điều kiện nếu cùng ngày ,cùng mã, trạng thái chờ xác nhận thì cập nhật! khác thì tạo mới
        var whereCheckCodeExist = {
          date_receipt_court:{_gte: dateFrom,_lte: dateTo},
          code_court: {_eq: data_import['code_court'].toString()},
          deleted: {_eq: false},
          status_document: {
            code: {'_eq': "WAITING"},
            deleted: {'_eq': false}
          }
        };
        var checkCodeExist = await this.$CoreService.getObjectData('document',whereCheckCodeExist);
       // console.log("checkCodeExistcheckCodeExistcheckCodeExistcheckCodeExist:",checkCodeExist);
        if (checkCodeExist){
          delete data_document.code_system;
          var id_document = checkCodeExist.id;
          //thì update
          var queryUpdateDocument = `
              mutation update_users_multil($document_object: document_set_input) {
                update_document(where: { id: {_eq: "${id_document}"}}, _set: $document_object) {
                  affected_rows
                  returning {
                    id
                  }
                }
              }
          `;//$where_delete_user_has_service: user_has_service_bool_exp!
          //list_change_docs

          let variables = {
            document_object: data_document,
          };
          this.$apollo.mutate({
            mutation: gql(queryUpdateDocument),
            variables: variables
          }).catch((error) => {
            this.$store.commit("setLoading", false);
            this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: "Tạo văn bản thất bại tại dòng thứ "+(i+1), life: life })
            console.error('ERROR: ', error)
            this.hasErrors = 1;
          });
          var data_document_edit = this.$commonFuction.convertJsonObject(data_document);
          data_document_edit.isedit =1;
          list_change_docs.push(data_document_edit)
        }else {
          //insert
          /*await this.$apollo.mutate({
            mutation: gql(graphql.CREATE_DOCUMENT),
            variables: {
              object: data_document,
            }
          }).catch((error) => {
            this.$store.commit("setLoading", false);
            this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: "Tạo văn bản thất bại tại dòng thứ "+(i+1), life: life })
            console.error('ERROR: ', error)
            this.hasErrors = 1;
          });*/
          await this.insert_doc(data_document,i,life)
          var data_document_add = this.$commonFuction.convertJsonObject(data_document);
          data_document_add.isadd =1;
          list_change_docs.push(data_document_add)
        }
       await this.$commonFuction.sleep(100)
      }
      if(this.hasErrors == 0){
        this.showload = false;
        var list_tmp = [];
        for (var u=0;u<list_change_docs.length;u++){
          list_tmp.push(list_change_docs[u])
          if (u==(list_change_docs.length-1) || u%15 == 0){
            await this.$commonFuction.sleep(10)
            await this.$CoreService.writeLogApi('import_docs','data import',list_tmp, store.getters.token);
            list_tmp = [];
          }
        }
          setTimeout(function () {
          console.log("list_change_docs:",list_change_docs)
          location.reload()
        }, 1000)
      }else{
        this.hasErrors = 0;
        this.showload = false;
      }
    },
    // async addData(worksheet_json){
    //   this.showload = true;
    //   let life = 1800000;
    //   for (let i = 0; i < worksheet_json.length; i++) {
    //     // that.$store.commit("setLoading", true);
    //     if (this.hasErrors == 1) {
    //       this.showload = true;
    //       break
    //     }
    //     const element = worksheet_json[i];
    //     var data_import = {}
    //     let counter = 0
    //     var data_document = {}
    //     for (const key in element) {
    //       if (Object.prototype.hasOwnProperty.call(element, key)) {
    //         let t = element[key];
    //         if (counter == 0) {
    //           data_import['code_office'] = t
    //         } else if (counter == 1) {
    //           data_import['code_area'] = t
    //         } else if (counter == 2) {
    //           data_import['code_court'] = t
    //         } else if (counter == 3) {
    //           data_import['number_decision'] = t
    //         } else if (counter == 4) {
    //           data_import['content_document'] = t
    //         } else if (counter == 5) {
    //           data_import['date_issued'] = t
    //         } else if (counter == 6) {
    //           data_import['date_invite'] = t
    //         } else if (counter == 7) {
    //           data_import['name_litigant'] = t
    //         } else if (counter == 8) {
    //           data_import['address'] = t
    //         } else if (counter == 9) {
    //           data_import['ward'] = t
    //         } else if (counter == 10) {
    //           data_import['district'] = t
    //         } else if (counter == 11) {
    //           data_import['state'] = t
    //         } else if (counter == 12) {
    //           data_import['signer'] = t
    //         } else if (counter == 13) {
    //           data_import['code_agency'] = t
    //         } else if (counter == 14) {
    //           data_import['is_urgent'] = t
    //         } else if (counter == 15) {
    //           data_import['is_fee_budget'] = t
    //         }
    //         //
    //       }
    //       counter++
    //     }
    //     // console.log('===> data import: ', data_import)
    //     if (data_import['code_court'] === '' || data_import['code_court'] == undefined) {
    //       this.showload = true;
    //       this.$toast.add({ severity: 'error', summary: 'Import văn bản lỗi', detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Mã văn bản tòa không được để trống", life: life })
    //       this.hasErrors = 1
    //       break
    //     }
    //     if (data_import['code_office'] === '' || data_import['code_office'] == undefined) {
    //       this.$toast.add({ severity: 'error', summary: 'Import văn bản lỗi', detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Mã văn phòng không được để trống", life: life })
    //       this.hasErrors = 1
    //       break
    //     }
    //     if (data_import['code_area'] === '' || data_import['code_area'] == undefined) {
    //       this.$toast.add({ severity: 'error', summary: 'Import văn bản lỗi', detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Mã khu vực không được để trống", life: life })
    //       this.hasErrors = 1
    //       break
    //     }
    //     if (data_import['code_agency'] === '' || data_import['code_agency'] == undefined) {
    //       this.$toast.add({ severity: 'error', summary: 'Import văn bản lỗi', detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Mã cơ quan không được để trống", life: life })
    //       this.hasErrors = 1
    //       break
    //     }
    //     if (data_import['number_decision'] === '' || data_import['number_decision'] == undefined) {
    //       this.$toast.add({ severity: 'error', summary: 'Import văn bản lỗi', detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Số quyết định tòa án không được để trống", life: life })
    //       this.hasErrors = 1
    //       break
    //     }
    //     if (data_import['content_document'] === '' || data_import['content_document'] == undefined) {
    //       this.$toast.add({ severity: 'error', summary: 'Import văn bản lỗi', detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Nội dung văn bản không được để trống", life: life })
    //       this.hasErrors = 1
    //       break
    //     }
    //     if (data_import['date_issued'] === '' || data_import['date_issued'] == undefined) {
    //       this.$toast.add({ severity: 'error', summary: 'Import văn bản lỗi', detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Ngày ban hành không được để trống", life: life })
    //       this.hasErrors = 1
    //       break
    //     }
    //     if (data_import['date_invite'] === '' || data_import['date_invite'] == undefined) {
    //       this.$toast.add({ severity: 'error', summary: 'Import văn bản lỗi', detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Ngày mời không được để trống", life: life })
    //       this.hasErrors = 1
    //       break
    //     }
    //     if (data_import['name_litigant'] === '' || data_import['name_litigant'] == undefined) {
    //       this.$toast.add({ severity: 'error', summary: 'Import văn bản lỗi', detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Tên đương sự không được để trống", life: life })
    //       this.hasErrors = 1
    //       break
    //     }
    //     if (data_import['address'] === '' || data_import['address'] == undefined) {
    //       this.$toast.add({ severity: 'error', summary: 'Import văn bản lỗi', detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Địa chỉ không được để trống", life: life })
    //       this.hasErrors = 1
    //       break
    //     }
    //     if (data_import['ward'] === '') {
    //       this.$toast.add({ severity: 'error', summary: 'Import văn bản lỗi', detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Phường/xã không được để trống", life: life })
    //       this.hasErrors = 1
    //       break
    //     }
    //     if (data_import['district'] === '') {
    //       this.$toast.add({ severity: 'error', summary: 'Import văn bản lỗi', detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Quận/huyện không được để trống", life: life })
    //       this.hasErrors = 1
    //       break
    //     }
    //     if (data_import['state'] === '') {
    //       this.$toast.add({ severity: 'error', summary: 'Import văn bản lỗi', detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Tỉnh/thành phố không được để trống", life: life })
    //       this.hasErrors = 1
    //       break
    //     }
    //     // check quận có thuộc tỉnh
    //     if (data_import['state'] in this.lstCurrState) {
    //       this.state_id = this.lstCurrState[data_import['state']]
    //       if ((data_import['district']+this.state_id in this.lstCurrDistrict) && (this.lstCurrDistrict[data_import['district']+this.state_id].state_id == this.state_id)) {
    //         this.district_id = this.lstCurrDistrict[data_import['district']+this.state_id].id
    //       }
    //       // console.log(that.district_id);
    //       if (!this.district_id || this.district_id == null) {
    //         this.$toast.add({
    //           severity: "error",
    //           summary: "Import văn bản thất bại",
    //           detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Quận/huyện không chính xác hoặc không thuộc Tỉnh/thành phố tương ứng",
    //           life: life
    //         });
    //         this.hasErrors = 1
    //         // return
    //       } else {
    //         // check phường xã
    //         // console.log(data_import['ward'])
    //         if ((data_import['ward']+this.district_id in this.lstCurrWard) && (this.lstCurrWard[data_import['ward']+this.district_id].district_id == this.district_id)) {
    //           this.ward_id = this.lstCurrWard[data_import['ward']+this.district_id].id
    //           // console.log(that.ward_id);
    //           if (!this.ward_id || this.ward_id == null) {
    //             this.$toast.add({
    //               severity: "error",
    //               summary: "Import văn bản thất bại",
    //               detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Phường/xã không chính xác hoặc không thuộc Quận/huyện tương ứng",
    //               life: life
    //             });
    //             this.hasErrors = 1
    //             break
    //           }
    //         } else {
    //           this.$toast.add({
    //             severity: "error",
    //             summary: "Import văn bản thất bại",
    //             detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Phường/xã không chính xác",
    //             life: life
    //           });
    //           this.hasErrors = 1
    //           break
    //         }
    //       }
    //     } else {
    //       this.$toast.add({
    //         severity: "error",
    //         summary: "Import văn bản thất bại",
    //         detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Tỉnh/thành phố không chính xác",
    //         life: life
    //       });
    //       this.hasErrors = 1
    //       break
    //     }
    //     // check mã văn phòng ko tồn tại
    //     if (data_import['code_office'] in this.lstCurrOfficeTPL) {
    //       this.tpl_id = this.lstCurrOfficeTPL[data_import['code_office']].id
    //     } else {
    //       this.$toast.add({
    //         severity: "error",
    //         summary: "Import văn bản thất bại",
    //         detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Mã văn phòng không chính xác",
    //         life: life
    //       });
    //       this.hasErrors = 1
    //       break
    //     }
    //     // check mã cơ quan ko tồn tại
    //     if (data_import['code_agency'] in this.lstCurrOfficeAgency) {
    //       this.agency_id = this.lstCurrOfficeAgency[data_import['code_agency']].id
    //     } else {
    //       this.$toast.add({
    //         severity: "error",
    //         summary: "Import văn bản thất bại",
    //         detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Mã văn phòng không chính xác",
    //         life: life
    //       });
    //       this.hasErrors = 1
    //       break
    //     }
    //     // check mã khu vực ko tồn tại
    //     if (data_import['code_area'] in this.lstCurrArea) {
    //       this.area_id = this.lstCurrArea[data_import['code_area']].id
    //     } else {
    //       this.$toast.add({
    //         severity: "error",
    //         summary: "Import văn bản thất bại",
    //         detail: "Dữ liệu lỗi ở dòng "+(i+1)+". Mã văn phòng không chính xác",
    //         life: life
    //       });
    //       this.hasErrors = 1
    //       break
    //     }
    //     // change data
    //     if (data_import['is_urgent'] == '' || data_import['is_urgent'] == null || data_import['is_urgent'] == undefined) {
    //       this.is_urgent = false
    //     } else {
    //       this.is_urgent = true
    //     }
    //     if (data_import['is_fee_budget'] == 'Ngân sách') {
    //       this.is_fee_budget = 1
    //     } else if (data_import['is_fee_budget'] == 'Đương sự') {
    //       this.is_fee_budget = 2
    //     } else {
    //       this.is_fee_budget = 0
    //     }

    //     // generate code system
    //     let cDate = moment(new Date()).format('DDMMYY');
    //     let cAgency = data_import['code_agency'].toString().substring(0, 2).toUpperCase();
    //     let cArea = data_import['code_area'].toString().substring(0, 2).toUpperCase();
    //     let cOffice = data_import['code_office'].toString().substring(0, 2).toUpperCase();
    //     var date1 = new Date().toISOString()
    //     date1 = moment(date1).utc(7).format('YYYY-MM-DDT00:00:00.0[Z]')
    //     var date2 = new Date().toISOString()
    //     date2 = moment(date2).utc(7).format('YYYY-MM-DDT23:59:59.0[Z]')
    //     var cNumber = 0;

    //     await this.$apollo.query({
    //       query: gql(graphql.GET_SETTING_CURRENT_DOCUMENT),
    //       variables: {
    //         where: {
    //           created_at: {'_gte': date1, '_lte': date2}
    //         },
    //         limit: 1
    //       },
    //       fetchPolicy: "network-only"
    //     }).then((res) => {
    //       if (res.data && res.data.setting_current_document.length > 0) {
    //         cNumber = res.data.setting_current_document[0].current + 1
    //       }
    //     })
    //     let sequence =  this.padLeft(cNumber, 4);
    //     this.code_system = cDate + cAgency + cArea + cOffice + sequence;

    //     // check tạo văn bản
    //     if (typeof data_import['date_invite'] === 'string') {
    //       let dateInvite = data_import['date_invite'].toString().split('/').reverse().join('-')
    //       dateInvite = new Date(dateInvite)
    //       data_document['date_invite'] = dateInvite.toISOString()
    //     }
    //     if (typeof data_import['date_issued'] === 'string') {
    //       let dateIssued = data_import['date_issued'].toString().split('/').reverse().join('-')
    //       dateIssued = new Date(dateIssued)
    //       data_document['date_issued'] = dateIssued.toISOString()
    //     }
    //     data_document['code_court'] = data_import['code_court'].toString()
    //     data_document['code_office'] = data_import['code_office'].toString()
    //     data_document['code_agency'] = data_import['code_agency'].toString()
    //     data_document['code_area'] = data_import['code_area'].toString()
    //     data_document['number_decision'] = data_import['number_decision'].toString()
    //     data_document['content_document'] = data_import['content_document'].toString()
    //     // data_document['date_issued'] = dateIssued.toISOString()
    //     // data_document['date_invite'] = dateInvite.toISOString()
    //     data_document['name_litigant'] = data_import['name_litigant'].toString()
    //     data_document['address'] = data_import['address'].toString()
    //     data_document['state_id'] = this.state_id
    //     data_document['district_id'] = this.district_id
    //     data_document['ward_id'] = this.ward_id
    //     data_document['is_fee_budget'] = this.is_fee_budget
    //     data_document['signer'] = data_import['signer'].toString()
    //     data_document['is_urgent'] = this.is_urgent
    //     await this.assignTDV(this.ward_id)
    //     data_document['tdv_id'] = this.tdv_id
    //     data_document['phone_tdv'] = this.phone_tdv
    //     //
    //     // console.log(that.is_urgent)
    //     if (Object.keys(this.lstCurrDocument).length > 0) {
    //       let keyExist = ''
    //       keyExist += data_import['code_area'].toString()+data_import['code_office'].toString()+data_import['code_court'].toString()+data_import['code_agency'].toString()+data_import['number_decision'].toString()
    //       if (keyExist in this.lstCurrDocument) {
    //         console.error('TRUNG DU LIEU DONG THU ' + parseInt(i + 1) + ' & ID: ' + this.lstCurrDocument[keyExist].id);
    //         // let cDate1 = that.lstCurrDocument[keyExist].code_system.substring(0, 6);
    //         // let cSequence = that.lstCurrDocument[keyExist].code_system.substring(that.lstCurrDocument[keyExist].code_system.length - 4, that.lstCurrDocument[keyExist].code_system.length);
    //         // let cAgency1 = data_import['code_agency'].toString().substring(0, 2).toUpperCase();
    //         // let cArea1 = data_import['code_area'].toString().substring(0, 2).toUpperCase();
    //         // let cOffice1 = data_import['code_office'].toString().substring(0, 2).toUpperCase();
    //         // data_document['code_system'] = cDate1 + cAgency1 + cArea1 + cOffice1 + cSequence;
    //         // CẬP NHẬT VĂN BẢN
    //         delete data_document.code_court
    //         delete data_document.code_office
    //         delete data_document.code_agency
    //         delete data_document.code_area
    //         await this.$apollo.mutate({
    //           mutation: gql(graphql.UPDATE_DOCUMENT),
    //           variables: {
    //             objInput: data_document,
    //             objWhere: {
    //               id: {'_eq': this.lstCurrDocument[keyExist].id}
    //             }
    //           }
    //         }).catch((error) => {
    //           this.$store.commit("setLoading", false);
    //           this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: "Tạo văn bản thất bại tại dòng thứ "+(i+1), life: life })
    //           console.error('ERROR: ', error)
    //           this.hasErrors = 1;
    //         });
    //       } else {
    //         // console.log('=============== tao van ban1: ')
    //         // TẠO MỚI VĂN BẢN
    //         data_document['code_system'] = this.code_system
    //         data_document['is_import'] = 1 // ĐỂ RUN TRIGGER UPDATE LOẠI VB
    //         data_document['status_td_id'] = null
    //         if(this.users_login !== null){
    //           data_document['created_uid'] = this.users_login;
    //         }
    //         await this.$apollo.mutate({
    //           mutation: gql(graphql.CREATE_DOCUMENT),
    //           variables: {
    //             object: data_document,
    //           }
    //         }).catch((error) => {
    //           this.$store.commit("setLoading", false);
    //           this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: "Tạo văn bản thất bại tại dòng thứ "+(i+1), life: life })
    //           console.error('ERROR: ', error)
    //           this.hasErrors = 1;
    //         });
    //       }
    //     } else {
    //       // console.log('=============== tao van ban2: ')
    //       // TẠO MỚI VĂN BẢN
    //       data_document['code_system'] = this.code_system
    //       data_document['is_import'] = 1 // ĐỂ RUN TRIGGER UPDATE LOẠI VB
    //       data_document['status_td_id'] = null
    //       if(this.users_login !== null){
    //         data_document['created_uid'] = this.users_login;
    //       }
    //       await this.$apollo.mutate({
    //         mutation: gql(graphql.CREATE_DOCUMENT),
    //         variables: {
    //           object: data_document,
    //         }
    //       }).catch((error) => {
    //         this.$store.commit("setLoading", false);
    //         this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: "Tạo văn bản thất bại tại dòng thứ "+(i+1), life: life })
    //         console.error('ERROR: ', error)
    //         this.hasErrors = 1;
    //       });
    //     }
    //   }
    //   if(this.hasErrors == 0){
    //     this.showload = false;
    //       setTimeout(function () {
    //       location.reload()
    //     }, 1000)
    //   }else{
    //     this.hasErrors = 0;
    //     this.showload = false;
    //   }
    // },
    /*async assignTDV(wardID) {
      // console.log(wardID)
      var {data} = await this.$apollo.query({
        query: gql(graphql.GET_USERS_WARD),
        variables: {
          where: {
            ward_id: {'_eq': wardID},
            user: {
              users_account: {
                role: {'_eq': 'tdv'}
              }
            }
          },
          distinct_on: "user_id",
          limit: 1
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      this.tdv_id = null;
      this.phone_tdv = null;
      if (model.length > 0) {
        this.tdv_id = model[0].user_id;
        this.phone_tdv = model[0].user.phone
      }
    },*/
    async assignTDV(wardID) {
      // console.log(wardID)
      /*var dataUser = null;
      var data = null;*/
      var model = null;
      var checkState = await this.$CoreService.getObjectData('state',{id: {_eq: this.state_id}})
      if (checkState.type == this.$constants.TYPE_STATE.URBAN){
        //Trường hợp nội thành
        /*dataUser = await this.$apollo.query({
          query: gql(graphql.GET_USERS_WARD),
          variables: {
            where: {
              ward_id: {'_eq': wardID},
              user: {
                users_account: {
                  role: {'_eq': 'tdv'}
                }
              }
            },
            distinct_on: "user_id",
            limit: 1
          },
          fetchPolicy: "network-only"
        })
        data = dataUser.data;*/
        model = await this.$CoreService.getListUserWard(wardID,1);
        this.tdv_id = null;
        if (model.length > 0) {
         // this.tdv_id = model[0].user_id;
          this.tdv_id = model[0].code;//code là user_id
        }
      }else {
        //Trường hợp ngoai thành
        /*dataUser = await this.$apollo.query({
          query: gql(graphql.GET_USERS_STATE),
          variables: {
            where: {
              state_id : {'_eq': this.state_id},
              user: {
                users_account: {
                  role: {'_eq': 'tdv'}
                }
              }
            },
            distinct_on: "user_id"
          },
          fetchPolicy: "network-only"
        })
        data = dataUser.data;*/
        model = await this.$CoreService.getListUserState(this.state_id,1);
        this.tdv_id = null;
        if (model.length > 0) {
          //this.tdv_id = model[0].user_id;
          this.tdv_id = model[0].code;//code là user_id
        }
      }
    },
    async insert_doc(data_document,i,life,count_func=0) {
      count_func++;
      var that = this
      var insertData = {
        'code': data_document.code_system
      }
      await this.$apollo.mutate({
        mutation: DataServices.insertData('document_temp'),
        variables: {
          'objects': insertData
        }
      }).then(async () => {
        await this.$apollo.mutate({
          mutation: gql(graphql.CREATE_DOCUMENT),
          variables: {
            object: data_document,
          }
        }).catch((error) => {
          this.$store.commit("setLoading", false);
          this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: "Tạo văn bản thất bại tại dòng thứ "+(i+1), life: life })
          console.error('ERROR: ', error)
          this.hasErrors = 1;
        });
        console.log("add 1")
      }).catch( async (error) => {
        console.error('ERROR: ', error)
        if (count_func==100){
          //dừng
          return false;
        }
        await that.insert_doc(data_document,i,life,count_func)
      })
      console.log("add 2")
    }
    ,
    padLeft(nr, n, str) {
      return Array(n - String(nr).length+1).join(str || '0') + nr;
    },
    convertViToEn(str, toUpperCase = false) {
      str = str.toLowerCase();
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
      str = str.replace(/đ/g, "d");
      // Some system encode vietnamese combining accent as individual utf-8 characters
      str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // Huyền sắc hỏi ngã nặng
      str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // Â, Ê, Ă, Ơ, Ư

      return toUpperCase ? str.toUpperCase() : str;
    },
    handlerGenerateJson() {
      console.log(this.padLeft(2300, 5));
      console.log(this.padLeft(23, 5, '>>'));
      console.log(moment(new Date()).format('DDMMYY'))
      console.log(this.convertViToEn('nGUYỄN Quốc Đạt'))
      console.log(this.convertViToEn('PHẦN MỘT. LỊCH SỬ THẾ GIỚI THỜI NGUYÊN THỦY, CỔ ĐẠI VÀ TRUNG ĐẠI').substring(0,2).toUpperCase())
      // this.createProvince();
      // this.createDistrict();
      // this.createWard();
    },
    createProvince() {
      var index = 0;
      var sql = [];
      while(index < this.provinces.length) { 
        if (index == this.provinces.length) break;
        const obj = this.provinces[index];
        var id = obj.id;
        var name = obj.name;
        sql.push('(' + id + ", '" + name + "')");
        index++;
      }
      console.log('INSERT INTO state(id, name) VALUES ' + sql.join(', '));
    },
    createDistrict() {
      var index = 0;
      this.districts = this.districts.filter(a => a.status === 1);
      var sql = [];
      // var sqlCity = [];
      while(index < this.districts.length) { 
        if (index == this.districts.length) break;
        const obj = this.districts[index];
        var id = obj.id;
        var name = obj.name;
        var province_id = obj.province_id;
        // console.log(id, name, province_id, typeof province_id);
        // if (province_id === "9") {
        //   console.log(province_id, typeof province_id);
        //   continue
        // }
        sql.push('(' + id + ", '" + name + "', " + province_id + ')');

        index++;
      }
      console.log('DATA', 'INSERT INTO district (id, name, state_id) VALUES ' + sql.join(', '));
    },
    createWard() {
      var index = 0;
      var sql = [];
      this.wards = this.wards.filter(a => a.status === 1);
      while(index < this.wards.length) { 
        if (index == this.wards.length) break;
        const obj = this.wards[index];
        var id = obj.id;
        var name = obj.name;
        var district_id = obj.district_id;

        var a = name.indexOf("'");
        // if (a !== -1) sql.push("(" + id + ", '" + name.replace("'", '"') + "', " + district_id + ", " + stt + ", now(), NULL, 1)");
        // else sql.push("(" + id + ", '" + name + "', " + district_id + ", " + stt + ", now(), NULL, 1)");
        if (a !== -1) sql.push('(' + id + ', "' + name + '", ' + district_id + ')');
        else sql.push('(' + id + ", '" + name + "', " + district_id + ')');
        index++;
      }
      console.log('DATA', 'INSERT INTO ward (id, name, district_id) VALUES ' + sql.join(', '));
    },
    // GỘP HÀM
    select_date(event,c) {
      console.log("col_namecol_name:",col_name);
      this.type_custom_filter = c.filter.type
      var col_name = c.key;
      if (this.filters[col_name][0] !== null && this.filters[col_name][1] !== null) {
        this.$emit("filter_date", {
          data: this.filters[col_name],
          col: col_name
        });
      }
    },
    getLabel(col) {
      var  str = col.name;
      if (col.label) str = col.label;
      return str.replace(/<[^>]+>/gm, '');
    },
    getLabelHtml(col) {
      var  str = col.name;
      if (col.label) str = col.label;
      return this.$helpers.stringToHTML(str);
    },
    getType(col) {
      if (col.display?.list?.mode == "custom") {
        return "Custom";
      }
      switch (col.type) {
        case "String":
        case "Text":
        case "Computed":
          if (col.inputOptions?.mode == "Image") {
            return "Image";
          }
          if (col.inputOptions?.mode == "selection") {
            return "Select";
          }
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          }
          if(col.inputOptions?.mode == 'icon') {
            return "Icon";
          }
          return "Input";
        case "numeric":
        case "ShadowField":
        case "number":
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          } else if (col.inputOptions?.mode == "percentage") {
            return "Percentage";
          } else {
            return "Number";
          }
        case "Selection":
          return "Select";
        case "Checkbox":
          return "Checkbox";
        default:
          return col.type;
      }
    },
    onInputChange(value, data, f) {
      if (f.onChange)  f.onChange(data).bind(this);
      this.$emit("onDataChange", data, f);
    },
    getCustomClass(col, data, rowData) {
      if (col.displayClass) return col.displayClass(data, rowData);
      return "";
    },
    getField(col) {
      return col.key;
    },
    getHeaderStyle(col) {
      var style = "";
      if (col.width) style = "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style = "width: 3em;";
      else if (col.type === "image" || col.type === "Image") style = "width: 6em;";
      return style;
    },
    getData(col, row) {
      var value = '';
      if (col.type == "Date" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("DD/MM/yyyy");
      } else if (col.type == "Datetime" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm:ss DD/MM/yyyy");
      } else if (col.type == "CustomDate" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm - DD/MM/yyyy");
      } else if(col.type == "Hour" && row[col.key]){
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm");
      } else if (col.type == "Selection") {
        var lists = [];
        if (col.options !== undefined) {
          lists = col.options;
        } else if (col.models !== undefined && this.options[col.key] !== undefined) {
          lists = this.options[col.key];
        }
        if (lists && lists.length) {
          var objResult = lists.filter(a => a.value == row[col.key]);
          if (objResult !== undefined && Object.keys(objResult) && Object.entries(objResult).length) {
            value = objResult[Object.keys(objResult)].label;
          }
        }
      } else {
        if (col.type == "Text" && row[col.key] && row[col.key].length > 100) {
          var result = row[col.key].substr(0, row[col.key].lastIndexOf(" ", 100)) + "...";
          value = result;
        }
        if (this.getType(col) == "Currency") {
          if (row[col.key] == null) row[col.key] = 0;
          value = this.formatCurrency(row[col.key]);
        }
        if (this.getType(col) == "Percentage") {
          if (row[col.key] == null) row[col.key] = `0%`;
          value = row[col.key] + "%";
        }
        value = row[col.key];
      }
      if (col.style) value = '<abbr style="' + col.style + '">' + value + '<abbr/>';
      else if (col.options) {
        var filtered = col.options.filter( a => a.value  === row[col.key]);
        if (Object.keys(filtered) && Object.entries(filtered).length && filtered[0].style) {
          value = '<abbr style="' + filtered[0].style + '">' + value + '<abbr/>';
        }
      } 
      return value
    },
    getFilterMatch(col) {
      var filterMatch = "startWith";
      if (col.filter && col.filter.match) {
        filterMatch = col.filter.match;
      }
      return filterMatch;
    },
    getFilterPlaceHolder(col) {
      if (col.filter.placeHolder) {
        return col.filter.placeHolder;
      } else if (col.filter.type == "select") {
        return `Chọn ${this.getLabel(col).toLowerCase()}`;
      } else if (col.filter.type == "input") {
        return `Nhập ${this.getLabel(col).toLowerCase()}`;
      } else {
        return `Lọc`;
      }
    },
    getSortable(col) {
      return col.sortable && col.sortable == true ? true : false;
    },
    getIcon(iconName) {
      return `pi pi-${iconName}`;
    },
    getDisabled(disabled = false) {
      return disabled;
    },
    getClass(type) {
      switch (type) {
        case "add":
          return "p-button-add";
        case "delete":
          return "p-button-danger";
        case "edit":
          return "p-button-edit";
        case "adddebt":
          return "p-button-edit"
        case "add-Debt":
          return "p-button-add";
        case "editcustom":
          return "p-button-edit"
        case "addcustom":
          return "p-button-add";
      }
    },
    formatCurrency(value) {
      return value.toLocaleString("vi-VN", {
        style: "currency",
        currency: "VND"
      });
    },
    customFilter( itemLabel, filterValue) {
      return this.$CoreService.customFilterCore(itemLabel, filterValue , this.dateType);
    },
    onFilterDate(payload) {
      if (payload.col.filter.type == 'Date') this.dateType = 1;
      else if (payload.col.filter.type == 'DateRange') this.dateType = 2;
      else this.dateType = 0;
      if (payload.type != undefined && payload.type != '' && (payload.type == 'from' || payload.type == 'to')) {
        if (this.filters[payload.col.key] == undefined ) this.filters[payload.col.key] = {};
        if (payload.data != undefined) {
          this.filters[payload.col.key][payload.type] = payload.data;
          if (this.filters[payload.col.key] != null && this.filters[payload.col.key]['from'] != null && this.filters[payload.col.key]['to'] != null) {
            var date1 = new Date(moment(this.filters[payload.col.key]['from']).format('YYYY-MM-DD'));
            var date2 = new Date(moment(this.filters[payload.col.key]['to']).format('YYYY-MM-DD'));
            if (Number(date1) > Number(date2)) {
              var dateTemp = this.filters[payload.col.key]['from'];
              this.filters[payload.col.key]['from'] = this.filters[payload.col.key]['to'];
              this.filters[payload.col.key]['to'] = dateTemp;
            }
          }
        }
        else delete this.filters[payload.col.key][payload.type];
      } else {
        this.filters[payload.col.key] = payload.data;
      }
      //croll lại vị trí filter
      this.$commonFuction.scroll_back_filter(payload.col.key+payload.type);
      this.componentKey = Math.random() * 320;
    },
    selectChangeDate(event, col, type = '') {
      var payload = {
        data: event,
        col: col,
        type: type,
        format: this.$commonFuction.formatDateCalenda('Date')
      }
      this.onFilterDate(payload);
    },
    clearChangeDate(col, type = '') {
      var date = this.filters[this.getField(col)];
      if (date != null) {
        if (type == '') delete this.filters[this.getField(col)];
        else if (type != '' && date[type] != undefined && date[type] != null) delete this.filters[this.getField(col)][type];
      }
      var payload = {
        col: col,
        type: type,
      }
      this.onFilterDate(payload);
    },
    getValueDateRange(col, target) {
      var date = this.filters[this.getField(col)];
      if (date != null) {
        if (target != '') {
          if (date[target] != undefined && date[target] != null) {
            return moment(date[target]).format(this.$commonFuction.formatDateCalenda('Date'));
          }
        } else return moment(date).format(this.$commonFuction.formatDateCalenda('Date'));
      }
      return null;
    },
  },
  apollo: {
    listData: {
      query() {
        this.modelName = this.$route.meta.model;
        return DataServices.getList(this.modelName);
      },
      variables: {
        where_key: {
          status_document: {
            code: {'_eq': "WAITING"},
            deleted: {'_eq': false}
          },
          // is_confirmed: {'_eq': false},
          deleted: {'_eq': false}
        },
        orderBy: {id: 'desc'}
      },
      update(data) {
        var listData = data[this.dataModel.tableName]
        // console.log(listData);
        this.title = this.dataModel.label + ' '
        this.dataModel.processData(listData)
        this.$store.commit('setLoading', false);
        this.componentKey += 1
        this.totalDoc = (data.document) ? data.document.length:0;
        return data[this.dataModel.tableName]
      },
      fetchPolicy: 'network-only',
      error() {
        this.$store.commit('setLoading', false);
      },
      skip() {
        return !this.modelName
      }
    }
  }

}
</script>
<style lang="scss">
.p-datepicker { top: 0px !important;}
.p-calendar .p-datepicker { width: 280px; padding: 0px; padding-top: 5px;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
.doc-header {
  &.doc-title {
    color: #1D3118;
    text-transform: capitalize;
    font-size: 18px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EEEEEE;
  }
}
.box-selected-file {
  // padding: 10px; 
  position: relative; 
  width: fit-content;
  float: right;
  margin-top: 5px;
  margin-bottom: 5px;
  input.file {position: absolute; opacity: 0;cursor: pointer;}
}
.box-selected-file span {
  padding: 7px 15px; 
  background: #0A84FF 0% 0% no-repeat padding-box;
  border: 1px solid #0A84FF; 
  border-radius: 3px; 
  cursor: pointer;
  font-size: 0.875rem;
  color: #ffffff;
}
.p-column-filter {
  .p-dropdown-label {
    &.p-inputtext {
      width: 40px;
      text-transform: unset;
    }
  }
}
</style>